<template>
  <div class="capital">
    <Header></Header>
    <div class="capital-banner flex-row">
      <div class="container business-banner-title">
        <p>产业投资</p>
        <p>
          中产资本在投资领域具备十几年实操经验，已成功投资国轩高科、容百科
        </p>
        <p>技、中节能太阳能等20多家公司并推动上市。</p>
      </div>
    </div>
    <div class="capital-synopsis">
      <h1>中国领先的产业投资基金管理公司</h1>
      <div class="desc container">
        <p>中产资本拥有险资LP管理资质，及欧擎资本、通盛时富两大备案机构，</p>
        <p>以资本推动产业导入。</p>
      </div>
      <div class="capital-scale container flex-row">
        <div v-for="(v,index) in capitalScaleList" :key="v.bg" :style="{background:`url(${v.bg})`}" class="capital-item flex-col wow animate__animated animate__fadeInUp" :data-wow-delay="'.'+index+'s'" data-wow-offset="0">
          <p>{{v.desc1}}</p>
          <p>{{v.desc2}}</p>
        </div>
      </div>
    </div>
    <div class="capital-service">
      <h1>资金配套服务，助推项目落地</h1>
      <div class="sub-desc container">
        <p>中产资本凭借数十家上市公司股东平台和强大的产业资源整合能力，可</p>
        <p>直接、间接为落地企业提供资金配套服务，减轻政府财政压力，推动优</p>
        <p>质项目顺利竣工、达产。</p>
      </div>
      <div class="process flex-row">
        <div class="flex-col process-item wow animate__animated animate__fadeInRight" data-wow-delay=".1s" data-wow-offset="0">
          <div class="icon">
            <img src="@/assets/images/business/capital1-icon.png" alt="">
          </div>
          <div class="desc">
            <p>管理地方政府</p>
            <p>产业引导基金</p>
          </div>
        </div>
        <div class="flex-row"><img src="@/assets/images/business/capital-point.png" alt=""></div>
        <div class="flex-col process-item wow animate__animated animate__fadeInRight" data-wow-delay=".2s" data-wow-offset="0">
          <div class="icon">
            <img src="@/assets/images/business/capital2-icon.png" alt="">
          </div>
          <div class="desc">
            <p>筛选产业项目</p>
          </div>
        </div>
        <div class="flex-row"><img src="@/assets/images/business/capital-point.png" alt=""></div>
        <div class="flex-col process-item wow animate__animated animate__fadeInRight" data-wow-delay=".3s" data-wow-offset="0">
          <div class="icon">
            <img src="@/assets/images/business/capital3-icon.png" alt="">
          </div>
          <div class="desc">
            <p>推动产业</p>
            <p>项目落地</p>
          </div>
        </div>
        <div class="flex-row"><img src="@/assets/images/business/capital-point.png" alt=""></div>
        <div class="flex-col process-item wow animate__animated animate__fadeInRight" data-wow-delay=".4s" data-wow-offset="0">
          <div class="icon">
            <img src="@/assets/images/business/capital4-icon.png" alt="">
          </div>
          <div class="desc">
            <p>促进产业</p>
            <p>规模扩张</p>
          </div>
        </div>
      </div>
    </div>

    <div class="capital-case">
      <h1>投资并推动上市公司案例</h1>
      <div style='margin-top:76px;' class="container-scroll">
        <vue-seamless-scroll :data="listData" class="warp" :step='40' :classOption="classOption">
          <div class="item flex-row" v-for="(v,i) in listData" :key="i">
            <div class="case-icon flex-row">
              <img :src="v.companyLogo" alt="">
            </div>
            <div class="code">{{v.stockCode}}</div>
            <div class="name">{{v.companyName}}</div>
          </div>
        </vue-seamless-scroll>
        <div class="top">
        </div>
        <div class="bottom">
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import "@/assets/css/capital.css";
import Header from './Header'
import Footer from './Footer'
export default {
  name: "Capital",
  components: {
    Header, Footer, vueSeamlessScroll
  },
  data () {
    return {
      capitalScaleList: [
        {
          bg: require("@/assets/images/business/capital-scale1.png"),
          desc1: "20个省市地方政府", desc2: "投融资财务顾问"
        },
        {
          bg: require("@/assets/images/business/capital-scale2.png"),
          desc1: "管理34支备案产业", desc2: "和股权投资基金"
        },
        {
          bg: require("@/assets/images/business/capital-scale3.png"),
          desc1: "累计管理规模", desc2: "超300亿元"
        },
        {
          bg: require("@/assets/images/business/capital-scale4.png"),
          desc1: "服务200多家大中型", desc2: "企业和上市公司"
        }
      ],
      listData: [],
      classOption: {
        step: .5
      }
    };
  },
  created () {
  },
  mounted () {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: true
    });
    wow.init();
    this.getCompany()
  },
  methods:{
    getCompany(){
      this.Axios.post(`/api/index/common/list/company`).then(res=>{
        this.listData=res.data.data
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Capital.vue